// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1z1pB","inner":"Footer_inner__nAPSJ"};